import React, { useState } from 'react'
import Sidebar from '../../components/Sidebar/Sidebar';
import { Layout, Menu } from "antd";
import PageContent from '../../components/PageContent/PageContent';
import TopBar from '../../components/TopBar/Navbar';

const { Sider, Content } = Layout;
export const CMS = () => {
    const [activePage, setActivePage] = useState("dashboard");
  
    return (
      <>
      <TopBar/>
      <Layout style={{ minHeight: "93vh", width: "100vw", marginTop:'6.5vh' }}>
        {/* Sidebar */}
        <Sidebar setActivePage={setActivePage} />
        {/* Nội dung */}
        <Layout style={{ padding: "20px" }}>
          <Content>
            <PageContent activePage={activePage} />
          </Content>
        </Layout>
      </Layout>
      </>
    );
  };
export default CMS;